const SETTINGS = {
  useFixtures: false,
  enableReactotron: true,
  logHttp: false,
  mobxSpy: false,
  useDevBackend: false
};

export default SETTINGS;



// WEBPACK FOOTER //
// ./src/App/Config/DebugSettings.js